import { Chip } from '@mui/material';

interface PatientSourceChipProps {
  name: string;
  color: string;
}

export function PatientSourceChip({ name, color }: PatientSourceChipProps) {
  return (
    <Chip
      label={name}
      size="small"
      sx={{
        height: 22,
        fontSize: '0.7rem',
        backgroundColor: `${color}18`,
        color,
        borderColor: `${color}40`,
        border: '1px solid',
      }}
    />
  );
}
